import {curry} from 'ramda';
import tryToCatch from 'try-to-catch';
import {setNotificationAction as setNotification} from '@pluto/notification/Redux/NotificationActions';
import {createContentPartner} from '@pluto/rest';

export const createContentPartnerAction = curry(async (params, dispatch) => {
    const {redirect, ...requestParams} = params;
    const [error] = await tryToCatch(createContentPartner, requestParams);

    redirect();

    if (!error) {
        return dispatch(
            setNotification({
                type: 'success',
                text: 'New content partner created',
            })
        );
    }

    const {data: errorData} = error.response;

    return dispatch(
        setNotification({
            type: 'error',
            text: errorData.message,
        })
    );
});
